import type { ReactNode } from "react";
import { VixioSymbol, Wordmark } from "@vixio/ui";
import { usePublicContacts } from "@vixio/core-ui";

/** E-mail de contato configurável (Configurações → Gerais), sem texto fixo no código. */
function ContactLink() {
  const c = usePublicContacts().data;
  if (!c?.contact_email) return <>fale com a equipe que convidou você</>;
  return <a href={`mailto:${c.contact_email}`}>{c.contact_email}</a>;
}

/** Tela de entrada. `area="portal"`: a mesma marca com a variação "Área do cliente". */
export function AuthLayout({ title, subtitle, children, area = "panel" }: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  area?: "panel" | "portal";
}) {
  const portal = area === "portal";
  return (
    <div className={portal ? "vx-auth vx-auth--portal" : "vx-auth"}>
      <div className="vx-auth__side">
        <div className="vx-auth__art" aria-hidden="true">
          <VixioSymbol size={360} />
        </div>
        <div className="vx-brand" style={{ border: 0, padding: 0, height: "auto" }}>
          <Wordmark label={portal ? "Vixio · Área do cliente" : undefined} />
        </div>
        {portal ? (
          <div className="vx-auth__claim">
            <p className="vx-auth__lede">
              A sua área na Vixio: acompanhe os projetos, aprove as entregas, veja faturas e notas, abra chamados e entre nas
              reuniões online, tudo num lugar só.
            </p>
            <hr className="vx-auth__rule" />
            <dl>
              <dt>Primeiro acesso</dt>
              <dd>use o link do convite que chegou no seu e-mail</dd>
              <dt>Esqueceu a senha</dt>
              <dd>peça um link novo na tela de entrada</dd>
              <dt>Ajuda</dt>
              <dd>
                <ContactLink />
              </dd>
            </dl>
          </div>
        ) : (
          <div className="vx-auth__claim">
            <p className="vx-auth__lede">
              Painel de gestão da Vixio: comercial, financeiro, fiscal e cadastro num só lugar, com o mesmo login da equipe,
              dos parceiros e dos clientes.
            </p>
            <hr className="vx-auth__rule" />
            <dl>
              <dt>Acesso</dt>
              <dd>restrito a membros convidados de cada organização</dd>
              <dt>Operações sensíveis</dt>
              <dd>estorno, anonimização e cancelamento de nota pedem 2FA</dd>
              <dt>Suporte</dt>
              <dd>
                <ContactLink />
              </dd>
            </dl>
          </div>
        )}
        <p className="muted" style={{ fontSize: "var(--fs-12)" }}>
          {portal ? `Vixio · ${window.location.host}/portal` : `Vixio · ${window.location.host}`}
        </p>
      </div>
      <main className="vx-auth__main">
        <div className="vx-auth__card">
          <h1 className="vx-auth__title">{title}</h1>
          {subtitle ? <p className="text-2" style={{ marginTop: 4, marginBottom: 20 }}>{subtitle}</p> : <div style={{ height: 20 }} />}
          {children}
        </div>
      </main>
    </div>
  );
}
